<div class="attributes-block">
    <div *ngFor="let entityAttributes of piiShieldEntitiesAttributes"
         class="entity-attributes"
         fxLayout="row" fxLayoutAlign="start center"
    >
        <div class="entity-title"
             fxLayout="column" fxLayoutAlign="center center"
        >
            <fa-icon
                icon="{{entityAttributes.entityType | ngcEntityIcon}}"
                class="entity-icon"
            >
            </fa-icon>
            <span>
                {{entityAttributes.entityType | ngcEntityName}}
            </span>
        </div>

        <div class="attr-container">

            <ng-container *ngIf="entityAttributes?.attributes?.length > 0">
                    <span *ngFor="let attribute of entityAttributes.attributes; let i = index"
                          class="attribute"
                          [ngClass]="actionClass || '' "
                    >
                {{attribute?.friendlyName || attribute?.propertyName || attribute}}
                        {{i < (entityAttributes.attributes.length - 1) ? ', ' : ''}}
            </span>
            </ng-container>

            <ng-container *ngIf="entityAttributes?.attributes?.length === 0">
                <span class="secondary-text">No attributes selected</span>
            </ng-container>
        </div>
    </div>
</div>
